var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingTapeShortLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 106,
    viewBox: "0 0 80 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 53.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8453 65.333H52.2453V51.533C52.2453 48.133 52.2453 40.733 41.9953 40.733C38.1953 40.733 34.4453 41.883 31.7953 44.583L34.9453 47.733C36.5453 46.233 38.8453 45.233 41.3453 45.233C44.5453 45.233 46.8453 46.783 46.8453 49.733V50.383H45.3453C39.3453 50.383 30.2453 50.933 30.2453 58.733C30.2453 63.483 34.5453 65.933 38.9953 65.933C42.1953 65.933 44.9953 64.733 46.6953 62.033H46.8453V65.333ZM46.4953 55.933C46.4953 59.283 44.5453 61.433 40.4453 61.433C38.4953 61.433 36.2453 60.483 36.2453 58.283C36.2453 54.833 41.9453 54.583 45.2453 54.583H46.4953V55.933Z",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8L-2.18557e-07 3C-2.9098e-07 1.34315 1.34315 3.27915e-06 3 3.20673e-06L77 -2.79171e-08C78.6569 -1.0034e-07 80 1.34315 80 3L80 8L0 8Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingTapeShortLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-tape-short-left.b51be0afcea71cf516b86ae47ea8556d.svg";
export { ForwardRef as ReactComponent };